// Dữ liệu mẫu Mint-Home, vai `sale` (mặc định của board) — nguồn: code board `Mint-Home.dc.html` (BRIEF / KPI). Không có tiền.
export type Tone = 'ok' | 'warn' | 'err' | 'n';
export interface Kpi { k: string; v: string; u: string; d: string; tone: Tone }

export const BRIEF_SALE =
  'Chào anh David. Hôm nay có 15 việc mở, 2 quá hạn (khoá cước SE260622020, báo giá cần duyệt giá SE260637300). 13 phiếu chờ anh ở ghế SALE-MGR và 8 phiếu ở ghế BOD-DDIR (quyền). Hôm nay anh đang thay TUANNT và PHONGNT.';

export const BRIEF_CHIPS: readonly { k: string; tone: Tone | 'pri' }[] = [
  { k: 'Việc mở 15', tone: 'n' },
  { k: 'Quá hạn 2', tone: 'err' },
  { k: 'Chờ duyệt 21', tone: 'pri' },
  { k: 'Đang thay TUANNT, PHONGNT · 6 việc', tone: 'n' },
];

export const KPI_SALE: readonly Kpi[] = [
  { k: 'Job tháng 10', v: '186', u: 'job', d: '+12 so với T9', tone: 'ok' },
  { k: 'Job đang chạy', v: '64', u: 'job', d: '19 BK/RQ Standby', tone: 'n' },
  { k: 'Cut-off 48 giờ', v: '9', u: 'job', d: '2 thiếu SI', tone: 'warn' },
  { k: 'Báo giá chấp nhận', v: '38', u: '%', d: '17 đang chờ', tone: 'n' },
];

/** Lịch sử 6 kỳ suy từ số hiện tại (minh hoạ — như board). */
export const kpiHist = (v: number): number[] => (v < 10 ? [2, 1, 3, 0, 1, 0].map((d) => v + d) : [0.8, 0.88, 0.85, 0.9, 0.94, 1].map((f) => Math.round(v * f)));

export function spark(h: readonly number[], w: number, hh: number): string {
  const mn = Math.min(...h), r = Math.max(...h) - mn || 1;
  return h.map((v, i) => `${i ? 'L' : 'M'}${(2 + (i * (w - 4)) / (h.length - 1)).toFixed(1)} ${(hh - 3 - ((v - mn) / r) * (hh - 6)).toFixed(1)}`).join(' ');
}

// ── Việc của tôi (N-04b) · nguồn: DK_TASKS_SALE / DK_LINK của code board. Không có tiền.
export type Grp = 'over' | 'today' | 'next';
export interface MyTask { id: number; code: string; title: string; obj: string; sub: string; grp: Grp; dueK: string; due: string; ext: string; act?: string }
export const MY_TASKS: readonly MyTask[] = [
  { id: 1, code: 'FRT', title: 'Khoá cước & dịch vụ trước ETD − 48h', obj: 'SE260622020', sub: 'GREENBUD · VNSGN → KRPUS', grp: 'over', dueK: 'Quá 3h', due: '22/Oct/2026 07:30', ext: '+4h 2/3', act: 'Khoá cước' },
  { id: 2, code: 'GPW', title: 'Báo giá cần duyệt giá', obj: 'SE260637300', sub: 'THANHHAO · VNSGN → KRINC', grp: 'over', dueK: 'Quá 1h', due: '22/Oct/2026 09:30', ext: '+4h 0/3', act: 'Xem duyệt giá' },
  { id: 3, code: 'PRC', title: 'Báo giá VNSGN → CNNGB 3×40HC cho TAMNGOC', obj: 'PR-261021-0946221', sub: 'Hỏi giá từ TUANNT', grp: 'today', dueK: 'Còn 2h 10′', due: '22/Oct/2026 12:40', ext: '+4h 0/3', act: 'Báo giá' },
  { id: 4, code: 'DUN', title: 'Nhắc nợ mốc +7 ngày — 2 debit quá hạn', obj: 'RUITONGVN-SC', sub: 'Debit DN26054118, DN26054131', grp: 'today', dueK: 'Còn 5h 30′', due: '22/Oct/2026 17:30', ext: '+4h 1/3', act: 'Nhắc nợ' },
  { id: 5, code: 'VCN', title: 'Báo khách đổi tàu: ETD 24 → 26/Oct', obj: 'SE260636780', sub: 'BAOANVISION · KMTC XIAMEN 2608N', grp: 'today', dueK: 'Còn 1h 45′', due: '22/Oct/2026 12:15', ext: '+4h 0/3', act: 'Gửi báo khách' },
  { id: 6, code: 'DCF', title: 'Debit chờ khách xác nhận — nhắc khách lần 2 (nhịp 2 ngày làm việc)', obj: 'DN26054044', sub: 'ARRIVE · nhắc qua mail + myHANA, cc Sale', grp: 'today', dueK: 'Còn 6h 40′', due: '22/Oct/2026 17:30', ext: '+4h 0/3', act: 'Nhắc khách' },
  { id: 7, code: 'SLD', title: 'Follow phiếu inquiry NAMMY — CNXMN 1×40HC', obj: 'PR-261021-0946207', sub: 'Hẹn gọi lại', grp: 'today', dueK: 'Còn 7h', due: '22/Oct/2026 17:30', ext: '+4h 0/3', act: 'Mở phiếu' },
  { id: 8, code: 'BKO', title: 'Đặt booking đúng ngày mở book — MSC FATMA QB641W', obj: 'SE260637400', sub: 'PHUCUONGEXIM · VNVUT → SAJED', grp: 'today', dueK: 'Còn 3h', due: '22/Oct/2026 13:30', ext: '+4h 0/3', act: 'Mở RQ' },
  { id: 12, code: '@', title: 'MAITTN nhắc anh: duyệt bỏ phí sửa bill', obj: 'SE260639420', sub: 'Chat Job · 09:42', grp: 'today', dueK: 'Hôm nay', due: '22/Oct/2026 17:30', ext: '+4h 0/3', act: 'Trả lời' },
  { id: 14, code: 'CCF', title: 'Thông quan tờ khai xuất — luồng chờ phân', obj: 'SE260637400', sub: 'PHUCUONGEXIM · dịch vụ CCF', grp: 'today', dueK: 'Còn 4h', due: '22/Oct/2026 15:30', ext: '+4h 0/3', act: 'Mở dịch vụ' },
  { id: 15, code: 'OPF', title: 'Follow cơ hội OPP-2610-0031 — GREENBUD Live tháng 11 (bước Báo giá)', obj: 'OPP-2610-0031', sub: 'GREENBUD · VNSGN → USLAX · hẹn chốt 24/Oct', grp: 'today', dueK: 'Còn 6h', due: '22/Oct/2026 17:00', ext: '+4h 0/3', act: 'Mở cơ hội' },
  { id: 9, code: 'LOI', title: 'LOI Telex bản ký chưa nhận (YML)', obj: 'SE260639370', sub: 'GREENBUD · Telex release', grp: 'next', dueK: 'Thứ Hai', due: '26/Oct/2026 10:00', ext: '+4h 0/3', act: 'Nhắc khách' },
  { id: 10, code: 'DMD', title: 'Sắp hết free time DEM — 2 ngày làm việc', obj: 'SI260600088', sub: 'QUEKYCORP · 2×40HC tại Cát Lái', grp: 'next', dueK: 'Ngày mai', due: '23/Oct/2026 17:30', ext: '+4h 0/3', act: 'Báo khách' },
  { id: 11, code: 'MEMO', title: 'Gọi anh Khoa (GREENBUD) về báo giá Live tháng 11', obj: '', sub: 'Ghi nhớ tự tạo', grp: 'next', dueK: 'Thứ Sáu', due: '23/Oct/2026 09:00', ext: '+4h 0/3' },
  { id: 13, code: 'TFN', title: 'Finish chuyến TRF2610077 — Bình Dương → Cát Lái', obj: 'TRF2610077', sub: 'COCOGROUP · Ref SE260609170 · 2×20DC', grp: 'next', dueK: 'Ngày mai', due: '23/Oct/2026 17:00', ext: '+4h 0/3', act: 'Finish chuyến' },
];
export const MY_DONE = 4;
export const GRP_LABEL: Record<Grp, string> = { over: 'Quá hạn', today: 'Hôm nay', next: 'Sắp tới' };

// Dữ liệu mẫu Duyệt chờ tôi, vai `sale` — trích nguyên từ code board Mint-Home.dc.html (DK_AP.sale, DK_AIC). Không có tiền.
export type ApCat = 'money' | 'hr' | 'other';
export interface ApStep { k: string; s: string; d: string }
export interface ApRow { id: number; ik: string; kind: string; title: string; by: string; when: string; note: string; steps: ApStep[]; cur: number; flags: { k: string; tip: string; c: string }[]; cat: ApCat }
export const AP_ROWS: readonly ApRow[] = [
 {
  "id": 101,
  "ik": "rel",
  "kind": "Release B/L khi còn nợ",
  "title": "Telex release SE260639370 · GREENBUD",
  "by": "[CSD-CSO] MAITTN",
  "when": "22/Oct 09:12",
  "note": "còn nợ quá hạn",
  "steps": [
   {
    "k": "CS đề nghị",
    "s": "MAITTN",
    "d": "d"
   },
   {
    "k": "Sale duyệt",
    "s": "[SALE-MGR] DAVID — trùng người ở bước Trưởng KD",
    "d": "c"
   },
   {
    "k": "Trưởng KD → đẩy KTT",
    "s": "[ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Bỏ qua Trưởng KD",
    "tip": "Sale và Trưởng KD là cùng một người → bước Trưởng KD đẩy lên ghế kế tiếp",
    "c": "warn"
   }
  ],
  "cat": "money"
 },
 {
  "id": 102,
  "ik": "mg",
  "kind": "Cần duyệt giá",
  "title": "Q26FRSGNPUS081 · VNSGN → KRINC 1×40RF",
  "by": "[SALE-SE] ANDG",
  "when": "22/Oct 08:40",
  "note": "cần duyệt giá trước khi gửi khách",
  "steps": [
   {
    "k": "Sale đề nghị",
    "s": "ANDG",
    "d": "d"
   },
   {
    "k": "Trưởng KD duyệt",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "money"
 },
 {
  "id": 103,
  "ik": "pay",
  "kind": "Đề nghị thanh toán",
  "title": "ODN2670057 · CMA CGM · debit 3 job",
  "by": "[ACC-CP] HANHLTM",
  "when": "21/Oct 16:05",
  "note": "3 job · có HĐ",
  "steps": [
   {
    "k": "Người lập",
    "s": "HANHLTM",
    "d": "d"
   },
   {
    "k": "Cấp 1",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "Kế toán trưởng · PAYMENT-APPROVE",
    "s": "[ACC-CA · Kế toán trưởng] Acting: NhungTT",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "money"
 },
 {
  "id": 104,
  "ik": "do",
  "kind": "Giữ DO — vượt hạn mức",
  "title": "DO SI260600088 · QUEKYCORP",
  "by": "[SALE-SE] TUANNT",
  "when": "22/Oct 10:02",
  "note": "vượt hạn mức",
  "steps": [
   {
    "k": "Sale đề nghị",
    "s": "TUANNT",
    "d": "d"
   },
   {
    "k": "Trưởng KD / KTT",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Thay cho TUANNT",
    "tip": "Anh đang được uỷ quyền phần khách của TUANNT",
    "c": "info"
   }
  ],
  "cat": "money"
 },
 {
  "id": 105,
  "ik": "lv",
  "kind": "Nghỉ phép",
  "title": "ANDG · nghỉ phép năm 27–28/Oct (2 ngày)",
  "by": "[SALE-SE] ANDG",
  "when": "21/Oct 17:20",
  "note": "backup: TUANNT · bàn giao 6 job",
  "steps": [
   {
    "k": "Người nghỉ",
    "s": "ANDG",
    "d": "d"
   },
   {
    "k": "Trưởng phòng",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "BOD (> 1 ngày)",
    "s": "[BOD-DIR] PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "hr"
 },
 {
  "id": 106,
  "ik": "ot",
  "kind": "Làm thêm giờ",
  "title": "Phiếu OT tự lập · THANHTTK · trực tối 21/Oct (1h15′)",
  "by": "[TRD-DSP] THANHTTK",
  "when": "22/Oct 07:05",
  "note": "từ log xử lý sự cố P0",
  "steps": [
   {
    "k": "Người trực xác nhận",
    "s": "THANHTTK",
    "d": "d"
   },
   {
    "k": "Trưởng Vận tải",
    "s": "[TRD-MGR] PHONGNT — thay cho (nghỉ phép) → cấp trên [SALE-MGR] DAVID",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Thay cho PHONGNT",
    "tip": "PHONGNT vắng · quyền duyệt chuyển cấp trên trực tiếp",
    "c": "info"
   }
  ],
  "cat": "hr"
 },
 {
  "id": 107,
  "ik": "spl",
  "kind": "Chia 2 Sale",
  "title": "Khách NAMMY · TUANNT 70% / ANDG 30% từ 01/Nov",
  "by": "[SALE-SE] TUANNT",
  "when": "20/Oct 15:30",
  "note": "KPI chia theo tỷ lệ",
  "steps": [
   {
    "k": "Sale đề nghị",
    "s": "TUANNT",
    "d": "d"
   },
   {
    "k": "Trưởng KD duyệt",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "other"
 },
 {
  "id": 108,
  "ik": "rop",
  "kind": "Mở lại job đã khoá",
  "title": "SE260639520 · bổ sung dòng phí hun trùng",
  "by": "[OPS-DOC] NGỌC",
  "when": "20/Oct 11:00",
  "note": "bổ sung dòng phí — xem ở màn tài chính",
  "steps": [
   {
    "k": "Người đề nghị",
    "s": "NGỌC",
    "d": "d"
   },
   {
    "k": "Trưởng KD",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "Kế toán mở khoá",
    "s": "[ACC-CA] vai trò KTT",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "other"
 },
 {
  "id": 109,
  "ik": "adm",
  "kind": "Thay đổi cấu hình",
  "title": "Ngưỡng release cần BOD (tham số tài chính)",
  "by": "[ADMIN] DAVID",
  "when": "19/Oct 18:10",
  "note": "tham số tài chính · cần duyệt trước",
  "steps": [
   {
    "k": "Người đề nghị",
    "s": "DAVID",
    "d": "d"
   },
   {
    "k": "BOD duyệt",
    "s": "[BOD-DDIR] DAVID (quyền)",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Tự duyệt",
    "tip": "BOD được tự duyệt; phiếu vào báo cáo kiểm soát tháng",
    "c": "warn"
   },
   {
    "k": "Cần mở từng phiếu",
    "tip": "Đổi tham số không duyệt hàng loạt",
    "c": "warn"
   }
  ],
  "cat": "other"
 },
 {
  "id": 110,
  "ik": "svc",
  "kind": "HĐ dịch vụ",
  "title": "HĐDV-2610-014 · TAMNGOC · khung 12 tháng FCL/LCL",
  "by": "[SALE-SE] TUANNT",
  "when": "21/Oct 14:30",
  "note": "điều khoản công nợ 30 ngày",
  "steps": [
   {
    "k": "Sale lập",
    "s": "TUANNT",
    "d": "d"
   },
   {
    "k": "Trưởng KD duyệt",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "Giám đốc ký",
    "s": "[BOD-DIR] PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "other"
 },
 {
  "id": 111,
  "ik": "lc",
  "kind": "HĐ lao động",
  "title": "HĐLĐ xác định thời hạn 12 tháng · NHI · CSD-BKG",
  "by": "[HRD-MGR] HẠNH",
  "when": "21/Oct 10:15",
  "note": "mẫu HDXDTH v3 · hết thử việc 31/Oct",
  "steps": [
   {
    "k": "HC-NS lập",
    "s": "HẠNH",
    "d": "d"
   },
   {
    "k": "Phó GĐ duyệt",
    "s": "[BOD-DDIR] DAVID (quyền)",
    "d": "c"
   },
   {
    "k": "Giám đốc ký",
    "s": "[BOD-DIR] PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "hr"
 },
 {
  "id": 112,
  "ik": "hrd",
  "kind": "Quyết định nhân sự",
  "title": "QĐ điều chuyển · TRÂN CSD-BKG → CSD-CSO từ 01/Nov",
  "by": "[HRD-MGR] HẠNH",
  "when": "20/Oct 16:00",
  "note": "khi duyệt tự áp vào hồ sơ + ghế",
  "steps": [
   {
    "k": "HC-NS lập",
    "s": "HẠNH",
    "d": "d"
   },
   {
    "k": "Trưởng phòng nhận",
    "s": "[CSD-MGR] Ghế trống · leo lên BOD-DDIR DAVID",
    "d": "c"
   },
   {
    "k": "Giám đốc ký",
    "s": "[BOD-DIR] PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Leo từ ghế trống",
    "tip": "Ghế CSD-MGR trống",
    "c": "warn"
   }
  ],
  "cat": "hr"
 },
 {
  "id": 113,
  "ik": "prl",
  "kind": "Bảng lương",
  "title": "Bảng lương kỳ 10/2026 · 37 nhân viên",
  "by": "[HRD-MGR] HẠNH",
  "when": "22/Oct 08:20",
  "note": "số liệu xem ở Bảng lương",
  "steps": [
   {
    "k": "HC-NS lập",
    "s": "HẠNH",
    "d": "d"
   },
   {
    "k": "Phó GĐ soát",
    "s": "[BOD-DDIR] DAVID (quyền)",
    "d": "c"
   },
   {
    "k": "Kế toán trưởng",
    "s": "[ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Cần mở từng phiếu",
    "tip": "Bảng lương không duyệt hàng loạt",
    "c": "warn"
   }
  ],
  "cat": "hr"
 },
 {
  "id": 114,
  "ik": "portal",
  "kind": "Tài khoản myHANA",
  "title": "myHANA · GREENBUD xin quyền xem Debit + Invoice",
  "by": "[SALE-SE] ANDG",
  "when": "22/Oct 09:40",
  "note": "MST đã khớp · Sale đã kiểm",
  "steps": [
   {
    "k": "Sale kiểm",
    "s": "ANDG",
    "d": "d"
   },
   {
    "k": "BOD cấp quyền",
    "s": "[BOD-DDIR] DAVID (quyền)",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "other"
 },
 {
  "id": 115,
  "ik": "adm",
  "kind": "Thay đổi cấu hình",
  "title": "Thêm ngày nghỉ #cty 24/Dec/2026 vào lịch làm việc",
  "by": "[HRD-MGR] HẠNH",
  "when": "22/Oct 10:05",
  "note": "WorkCalendar · ảnh hưởng hạn việc & công",
  "steps": [
   {
    "k": "Người đề nghị",
    "s": "HẠNH",
    "d": "d"
   },
   {
    "k": "BOD duyệt",
    "s": "[BOD-DDIR] DAVID (quyền)",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "other"
 },
 {
  "id": 116,
  "ik": "err",
  "kind": "Sai sót",
  "title": "Ghi nhận sai sót · SE260636900 gửi Final B/L trễ · MAITTN",
  "by": "[CSD-TL] HOATTN",
  "when": "21/Oct 18:00",
  "note": "trừ điểm KPI tháng 10",
  "steps": [
   {
    "k": "Trưởng nhóm ghi",
    "s": "HOATTN",
    "d": "d"
   },
   {
    "k": "Trưởng phòng xác nhận",
    "s": "[CSD-MGR] Ghế trống · leo lên BOD-DDIR DAVID",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "hr"
 },
 {
  "id": 117,
  "ik": "cost1",
  "kind": "Đề nghị cấp 1",
  "title": "Phát sinh SE260637400 · nâng hạ thêm 2 cont",
  "by": "[OPS-FLD] HOÀNG",
  "when": "22/Oct 07:50",
  "note": "có hoá đơn cảng",
  "steps": [
   {
    "k": "Hiện trường lập",
    "s": "HOÀNG",
    "d": "d"
   },
   {
    "k": "Cấp 1",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "Kế toán ghi sổ",
    "s": "[ACC-CP] HANHLTM",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "money"
 },
 {
  "id": 118,
  "ik": "soa",
  "kind": "SOA đối chiếu",
  "title": "SOA tháng 10 · ARRIVE · 6 debit",
  "by": "[ACC-AR] NGỌC ANH",
  "when": "21/Oct 15:10",
  "note": "gửi khách sau khi Sale xác nhận",
  "steps": [
   {
    "k": "Kế toán lập",
    "s": "NGỌC ANH",
    "d": "d"
   },
   {
    "k": "Sale xác nhận",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "money"
 },
 {
  "id": 119,
  "ik": "rfd",
  "kind": "Hoàn tiền khách",
  "title": "Hoàn cọc cont DN26054012 · NAMMY",
  "by": "[ACC-AR] NGỌC ANH",
  "when": "20/Oct 09:30",
  "note": "đã trả rỗng đúng hạn",
  "steps": [
   {
    "k": "Kế toán lập",
    "s": "NGỌC ANH",
    "d": "d"
   },
   {
    "k": "Sale xác nhận",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "Kế toán trưởng · PAYMENT-APPROVE",
    "s": "[ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "money"
 },
 {
  "id": 120,
  "ik": "bank",
  "kind": "Xác minh TK ngân hàng",
  "title": "TK nhận tiền mới · nhà xe ONGVANG",
  "by": "[ACC-CP] HANHLTM",
  "when": "22/Oct 08:05",
  "note": "đổi TK nhận · gọi xác minh 2 chiều",
  "steps": [
   {
    "k": "Kế toán nhập",
    "s": "HANHLTM",
    "d": "d"
   },
   {
    "k": "BOD xác minh",
    "s": "[BOD-DDIR] DAVID (quyền)",
    "d": "c"
   }
  ],
  "cur": 1,
  "flags": [
   {
    "k": "Cần mở từng phiếu",
    "tip": "Đổi tài khoản nhận tiền phải mở và gọi xác minh",
    "c": "warn"
   }
  ],
  "cat": "money"
 },
 {
  "id": 121,
  "ik": "iin",
  "kind": "HĐ mua vào",
  "title": "HĐ mua vào 0004812 · Wan Hai · lệch 1 dòng phí",
  "by": "[ACC-CP] HANHLTM",
  "when": "21/Oct 11:40",
  "note": "lệch THC so với debit",
  "steps": [
   {
    "k": "Kế toán nhập",
    "s": "HANHLTM",
    "d": "d"
   },
   {
    "k": "Sale xác nhận",
    "s": "[SALE-MGR] DAVID",
    "d": "c"
   },
   {
    "k": "Ghi sổ · INVOICE-IN-POST",
    "s": "[ACC-CP] HANHLTM",
    "d": "n"
   }
  ],
  "cur": 1,
  "flags": [],
  "cat": "money"
 }
] as ApRow[];
export const AP_ICON: Record<string, string> = {"rel":"M7 3h8l4 4v14H7z M15 3v4h4 M9 14l2 2 4-4","do":"M3 8h18v10H3z M7 8v10 M15 8v10","mg":"M20 12 12 20 4 12V4h8z M8.5 8.5h.01","pay":"M4 6h16v12H4z M4 10h16 M8 15h3","lv":"M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4","ot":"M12 7v5l3 2 M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z","adm":"M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M12 2v3 M12 19v3 M2 12h3 M19 12h3","rop":"M3 12a9 9 0 1 0 3-6.7L3 8 M3 3v5h5","spl":"M6 3v12 M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M18 9a9 9 0 0 1-9 9","svc":"M7 3h8l4 4v14H7z M15 3v4h4 M9 13h6 M9 17h4","lc":"M7 3h8l4 4v14H7z M15 3v4h4 M10 15l2 2 3-4","hrd":"M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M3 21a6 6 0 0 1 12 0 M17 11l2 2 4-4","prl":"M3 6h18v12H3z M12 9v6 M9 12h6","portal":"M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M3 12h18 M12 3a14 14 0 0 1 0 18","err":"M12 9v4 M12 17h.01 M10.3 3.9 2 18a2 2 0 0 0 1.7 3h16.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z","cost1":"M4 4h16v16H4z M8 12h8","soa":"M4 4h16v16H4z M8 9h8 M8 13h8 M8 17h5","rfd":"M3 12a9 9 0 1 0 3-6.7L3 8 M3 3v5h5","bank":"M3 10l9-6 9 6 M5 10v8 M19 10v8 M9 10v8 M15 10v8 M3 20h18","iin":"M6 3h12v18l-3-2-3 2-3-2-3 2z M9 8h6 M9 12h6"};
export const AP_SRC: Record<string, string> = {"rel":"Mint-BL.dc.html","mg":"Mint-Quote.dc.html","pay":"Mint-SupplierPay.dc.html","do":"Mint-Import.dc.html","lv":"Mint-HR.dc.html","ot":"Mint-HR.dc.html","spl":"Mint-Customers.dc.html","rop":"Mint-JobDetail.dc.html","adm":"Mint-Admin.dc.html","svc":"Mint-Contract.dc.html","lc":"Mint-LaborContract.dc.html","hrd":"Mint-HRDecision.dc.html","prl":"Mint-Payroll.dc.html","portal":"Mint-PortalApprove.dc.html","err":"Mint-KPI.dc.html","cost1":"Mint-Cost.dc.html","soa":"Mint-AR.dc.html","rfd":"Mint-AR.dc.html","bank":"Mint-SupplierPay.dc.html","iin":"Mint-Cost.dc.html"};

// ── Tin nội bộ (N-04d) · nguồn: board Mint-Home `NEWS` (6 tin). `c` = màu nhấn riêng từng tin (dữ liệu, không phải token).
export type NewsAud = 'VanPhong' | 'TaiXe' | 'KhachHang';
export interface News { id: string; k: string; cat: string; aud: readonly NewsAud[]; by: string; when: string; views: number; c: string; tags: readonly string[]; album?: number; body: readonly string[] }
export const NEWS: readonly News[] = [
  { id: 'n1', k: 'Lịch nghỉ Tết Dương lịch 2027', cat: 'Thông báo', aud: ['VanPhong', 'TaiXe'], by: 'HC–NS · HẠNH', when: '20/Oct/2026', views: 128, c: '#1D6FD8', /* token-ok: màu nhấn riêng của tin */ tags: ['nghỉ lễ'], body: ['Công ty nghỉ Tết Dương lịch từ 01/Jan/2027 đến hết 03/Jan/2027 theo lịch làm việc đã cập nhật ở Nhân sự › Giờ làm việc & lễ.', 'Bộ phận trực (BKG, Điều độ) đăng ký lịch trực với trưởng phòng trước 15/Dec/2026.'] },
  { id: 'n2', k: 'Quy trình mới: Draft B/L chỉ gửi từ Chứng từ & B/L', cat: 'Quy trình', aud: ['VanPhong'], by: 'BOD · PHILIP', when: '18/Oct/2026', views: 96, c: '#0F766E', /* token-ok: màu nhấn riêng của tin */ tags: ['B/L', 'SOP'], body: ['Từ 01/Nov/2026, Draft / Final / Release B/L gửi khách chỉ qua Chứng từ & B/L để có xác nhận và lịch sử.', 'HANA Box sẽ cảnh báo khi thư thường có đính kèm B/L.'] },
  { id: 'n3', k: 'Chào mừng 3 bạn mới phòng CS và BKG', cat: 'Con người', aud: ['VanPhong'], by: 'HC–NS · HẠNH', when: '16/Oct/2026', views: 141, c: '#8380E8', /* token-ok: màu nhấn riêng của tin */ tags: ['nhân sự mới'], body: ['Chào mừng ThuyNTT (CS), TranTPB và NhiTHT (BKG) gia nhập HANA từ tháng 10.', 'Lộ trình học SOP đã giao ở Đào tạo.'] },
  { id: 'n4', k: 'An toàn khi chạy đêm mùa mưa', cat: 'An toàn', aud: ['TaiXe'], by: 'Vận tải · PHONGNT', when: '15/Oct/2026', views: 37, c: '#B45309', /* token-ok: màu nhấn riêng của tin */ tags: ['tài xế'], body: ['Giảm tốc khi qua cầu Phú Mỹ lúc mưa lớn, bật đèn sương mù.', 'Báo Điều độ ngay khi kẹt xe quá 30 phút để báo khách.'] },
  { id: 'n5', k: 'Tuyến mới VNSGN → SGSIN hàng LCL hằng tuần', cat: 'Dịch vụ', aud: ['KhachHang', 'VanPhong'], by: 'Kinh doanh · DAVID', when: '12/Oct/2026', views: 210, c: '#47A6F5', /* token-ok: màu nhấn riêng của tin */ tags: ['LCL', 'SIN'], body: ['HANA mở chuyến gom hàng LCL đi Singapore mỗi thứ Sáu, cắt máng thứ Tư.', 'Khách đặt chỗ qua myHANA hoặc Sale phụ trách.'] },
  { id: 'n6', k: 'Album · Team building Vũng Tàu 10/2026', cat: 'Sự kiện', aud: ['VanPhong'], by: 'HC–NS · HẠNH', when: '06/Oct/2026', views: 188, c: '#22C55E', /* token-ok: màu nhấn riêng của tin */ tags: ['album'], album: 24, body: ['24 ảnh từ chuyến team building ngày 04–05/Oct/2026 tại Vũng Tàu.'] },
];
export const NEWS_AUD: readonly (readonly [NewsAud | 'all', string])[] = [['all', 'Tất cả'], ['VanPhong', 'Văn phòng'], ['TaiXe', 'Tài xế'], ['KhachHang', 'Khách hàng']];
export const NEWS_CATS: readonly string[] = ['Tất cả danh mục', ...Array.from(new Set(NEWS.map((n) => n.cat)))];
